export enum LibraryFilter {
  Subject = 'subject_subtree_of_id',
  Tag = 'tag_id',
  Publisher = 'conference_id',
  Year = 'year_held_at',
  Package = 'package',
  YearStartsAt = 'year_starts_at',
  Event = 'event_id',
}
